export default __webpack_public_path__ + "static/media/Iron_Fortress.ac9223f6.jpg";